import { Routes } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { UserManagementComponent } from './features/users/user-management/user-management.component';
import { TaskListComponent } from './features/tasks/task-list/task-list';

import { TaskDetailComponent } from './features/tasks/task-detail/task-detail';
import { TechnicianScreenComponent } from './features/users/technician-screen/technician-screen.component';
import { authGuard } from './core/guards/auth.guard';
import { ConversationListComponent } from './features/chat/conversation-list/conversation-list.component';
import { ChatPageComponent } from './features/chat/chat-page/chat-page.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { CoordinatorsComponent } from './features/users/coordinators/coordinators.component';
import { ReportingComponent } from './features/reporting/reporting.component';
import { ProfileSettingsComponent } from './features/settings/profile-settings/profile-settings.component';
import { SettingsComponent } from './features/settings/settings.component';
import { SETTINGS_ROUTES } from './features/settings/settings.routes';
import { NotificationsPageComponent } from './features/notifications/notifications-page.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'notifications',
    component: NotificationsPageComponent,
    canActivate: [authGuard],
    data: { roles: ['Administrator', 'Coordinator', 'Technician'] }
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    data: { roles: ['Administrator'] },
    loadChildren: () => import('./admin.routes').then(m => m.ADMIN_ROUTES)
  },
  {
    path: 'coordinator',
    canActivate: [authGuard],
    data: { roles: ['Coordinator'] },
    loadChildren: () => import('./coordinator.routes').then(m => m.COORDINATOR_ROUTES)
  },
  {
    path: 'technician',
    canActivate: [authGuard],
    data: { roles: ['Technician'] },
    loadChildren: () => import('./technician.routes').then(m => m.TECHNICIAN_ROUTES)
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' }
];
